// fetchBrands.js
import axiosInstance from "../../../service/AxiosInstance";

export const fetchBrands = async () => {
  try {
    const response = await axiosInstance.get(`/brand`, {
      params: {
        column: "name",
      },
    }); // Replace with your group API endpoint
    return response.data;
  } catch (error) {
    console.error("Error fetching brands:", error);
    return [];
  }
};

export const fetch_radius_per_miles = async () => {
  try {
    const response = await axiosInstance.get(
      `/dealer_radius_factor?type=StepsOptions`
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return[]
  }
};

export const fetchPortfolioTypes = async () => {
  try {
    const { data } = await axiosInstance.get(`/portfolio_type`);
    return data
  } catch (error) {
    console.error("Error fetching portfolio Types", error);
    return []
  }
};

export const fetchStates = async () => {
  try {
    const response = await axiosInstance.get(`/state`, {
      params: {
        column: "name",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching states:", error);
    return [];
  }
};

export const fetchPreviousFeedbacks = async () => {
  try {
    const response = await axiosInstance.get("/report-feedback");
    
    if (response.data && response.data.success) {
      return response.data.data || [];
    } else {
      console.error("Failed to fetch previous feedbacks:", response.data);
      return [];
    }
  } catch (error) {
    console.error("Error fetching previous feedbacks:", error);
    return [];
  }
};

// AI Analytics Pending Reports Storage Functions
export const loadPendingReports = () => {
  try {
    const saved = sessionStorage.getItem('aiAnalyticsPendingReports');
    if (saved) {
      const reports = JSON.parse(saved);
      // Filter out reports older than 24 hours to prevent stale data
      const twentyFourHoursAgo = Date.now() - (24 * 60 * 60 * 1000);
      return reports.filter(report => report.startTime > twentyFourHoursAgo);
    }
  } catch (error) {
    console.error('Error loading pending reports from sessionStorage:', error);
  }
  return [];
};

export const savePendingReports = (reports) => {
  try {
    sessionStorage.setItem('aiAnalyticsPendingReports', JSON.stringify(reports));
  } catch (error) {
    console.error('Error saving pending reports to sessionStorage:', error);
  }
};